import { vuexLogistic } from '@/store/composition/module/logistic'
import { LOGISTIC_OBJECT_URL } from '@/api/Logistic'

const state = () => ({
  ...vuexLogistic.createState(),
  urlApi: LOGISTIC_OBJECT_URL,
  expand: 'work',
  deleteResponseKey: 'name',

  tableHeaders: [
    {
      title: 'Наименование',
      isSortable: false
    },
    {
      title: 'Шифр',
      isSortable: false
    },
    {
      title: 'ФИО Мастера',
      isSortable: false
    },
    {
      title: 'Примечание',
      isSortable: false
    }
  ]
})

const getters = {
  ...vuexLogistic.createGetters(),

  getList: state => {
    return state.list.map(item => {
      return {
        id: item.id,
        isActive: item.isActive,
        values: [
          item.name,
          item.code,
          item.master || '-',
          item.comment || '-'
        ]
      }
    })
  },

  itemIsUsed: state => {
    return state.checkedDeleteItem?.work?.length
  }
}

const mutations = {
  ...vuexLogistic.createMutations()
}

const actions = {
  ...vuexLogistic.createActions()
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
